'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _stream = require('stream');

var _stream2 = _interopRequireDefault(_stream);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ChunkStream = function (_Stream) {
  _inherits(ChunkStream, _Stream);

  function ChunkStream() {
    _classCallCheck(this, ChunkStream);

    var _this = _possibleConstructorReturn(this, (ChunkStream.__proto__ || Object.getPrototypeOf(ChunkStream)).call(this));

    _this._buffers = [];
    _this._buffered = 0;

    _this._reads = [];
    _this._paused = false;

    _this._encoding = 'utf8';
    _this.writable = true;
    _this._hasErrd = false;
    _this._setError = _this._setError.bind(_this);
    _this.on('error', function () {
      return _this._setError(true);
    });
    return _this;
  }

  _createClass(ChunkStream, [{
    key: '_setError',
    value: function _setError(status) {
      this._hasErrd = status;
    }
  }, {
    key: 'read',
    value: function read(length, callback) {
      this._reads.push({
        length: Math.abs(length), // if length < 0 then at most this length
        allowLess: length < 0,
        func: callback
      });

      process.nextTick(function () {
        this._process();

        // its paused and there is not enought data then ask for more
        if (this._paused && this._reads.length > 0) {
          this._paused = false;

          this.emit('drain');
        }
      }.bind(this));
    }
  }, {
    key: 'write',
    value: function write(data, encoding) {
      if (!this.writable) {
        this.emit('error', new Error('Stream not writable'));
        return false;
      }

      var dataBuffer;
      if (Buffer.isBuffer(data)) {
        dataBuffer = data;
      } else {
        dataBuffer = new Buffer(data, encoding || this._encoding);
      }

      this._buffers.push(dataBuffer);
      this._buffered += dataBuffer.length;

      this._process();

      // ok if there are no more read requests
      if (this._reads && this._reads.length === 0) {
        this._paused = true;
      }

      return this.writable && !this._paused;
    }
  }, {
    key: 'end',
    value: function end(data, encoding) {
      if (data) {
        this.write(data, encoding);
      }

      this.writable = false;

      // already destroyed
      if (!this._buffers) {
        return;
      }

      // enqueue or handle end
      if (this._buffers.length === 0) {
        this._end();
      } else {
        this._buffers.push(null);
        this._process();
      }
    }
  }, {
    key: '_end',
    value: function _end() {
      if (this._reads.length > 0 && !this._hasErrd) {
        this.emit('error', new Error('There are some read requests waiting on finished stream'));
      }

      this.destroy();
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      if (!this._buffers) {
        return;
      }

      this.writable = false;
      this._reads = null;
      this._buffers = null;

      this.emit('close');
    }
  }, {
    key: '_processReadAllowingLess',
    value: function _processReadAllowingLess(read) {
      // ok there is any data so that we can satisfy this request
      this._reads.shift(); // == read

      // first we need to peek into first buffer
      var smallerBuf = this._buffers[0];

      // ok there is more data than we need
      if (smallerBuf.length > read.length) {

        this._buffered -= read.length;
        this._buffers[0] = smallerBuf.slice(read.length);

        read.func.call(this, smallerBuf.slice(0, read.length));
      } else {
        // ok this is less than maximum length so use it all
        this._buffered -= smallerBuf.length;
        this._buffers.shift(); // == smallerBuf

        read.func.call(this, smallerBuf);
      }
    }
  }, {
    key: '_processRead',
    value: function _processRead(read) {
      this._reads.shift(); // == read

      var pos = 0;
      var count = 0;
      var data = new Buffer(read.length);

      // create buffer for all data
      while (pos < read.length) {

        var buf = this._buffers[count++];
        var len = Math.min(buf.length, read.length - pos);

        buf.copy(data, pos, 0, len);
        pos += len;

        // last buffer wasn't used all so just slice it and leave
        if (len !== buf.length) {
          this._buffers[--count] = buf.slice(len);
        }
      }

      // remove all used buffers
      if (count > 0) {
        this._buffers.splice(0, count);
      }

      this._buffered -= read.length;

      read.func.call(this, data);
    }
  }, {
    key: '_process',
    value: function _process() {
      try {
        // as long as there is any data and read requests
        while (this._buffered > 0 && this._reads && this._reads.length > 0) {
          var read = this._reads[0];

          // read any data (but no more than length)
          if (read.allowLess) {
            this._processReadAllowingLess(read);
          } else if (this._buffered >= read.length) {
            // ok we can meet some expectations

            this._processRead(read);
          } else {
            // not enought data to satisfy first request in queue
            // so we need to wait for more
            break;
          }
        }

        if (this._buffers && this._buffers.length > 0 && this._buffers[0] === null) {
          this._end();
        }
      } catch (ex) {
        this.emit('error', ex);
      }
    }
  }]);

  return ChunkStream;
}(_stream2.default);

exports.default = ChunkStream;


ChunkStream.prototype.destroySoon = ChunkStream.prototype.end;


//////////////////
// WEBPACK FOOTER
// ./node_modules/pngjs3/dist/chunkstream.js
// module id = 452
// module chunks = 0